/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/atanh.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns the inverse hyperbolic tangent of a number.',
  examples: [
    'ROW a=0.5\n| EVAL atanh=ATANH(a)',
  ],
  params: {
    number: 'Number between -1 and 1. If `null`, the function returns `null`.',
  },
};

export default docs;
